export const projects = [
    {
        title: "Launch Pad",
        subtitle: "React and Custom Express API",
        description:
            "Platform that gathers relevant information for upcoming rocket launches and allows users to search youtube for videos related to rocket science.  Displays the current Location of the ISS in low-Earth orbit.",
        image: "./assets/LaunchPad.gif",
        link: "http://launchpadone.herokuapp.com",
    },
    {
        title: "Tetris Wave JS",
        subtitle: "Vanilla JS!",
        description:
            "Tetris clone rendering in the browser using native JavaScript, HTML, and CSS.  Custom styling and music for your pleasure. Enjoy the music, relax, and be transported back to a simpler time. With a twist of course...",
        image: "./assets/TetrisWave.gif",
        link: "http://frozen-fortress-81799.herokuapp.com",
    },
];

